import React from "react";
import { DataGrid, GridFooter, GridFooterContainer } from "@mui/x-data-grid";
import Pagination from "pages/homeDashboard/components/Pagination/Pagination";

import ExpandableGrid from "components/shared/ExpandableGrid/ExpandableGrid";
import TableRowsSkeleton from "../TableRowsSkeleton/TableRowsSkeleton";

import "./AdminDataGrid.css";

const AdminDataGrid = ({
  rows,
  selectedRows,
  columns,
  setSelectedRows,
  queryData,
  setShowModalMulti,
  setMultiSelectAction,
  isMultiActionLoading,
  isTableLoading,
  isInitialLoading = false,
  setCurrentPage,
  currentPage,
  totalCount,
  recordsPerPage,
  onRecordsPerPageChange,
  defaultRecordsPerPage = 10,
  filtersSlot,
  chipsSlot,
  canReviewRequests = true,
}) => {
  // MUI DataGrid Options
  const dataGridKey = JSON.stringify(rows);
  const customLocaleText = {
    noRowsLabel: "No Pending Requests",
  };

  // Open multi select modal
  const openModal = (action) => {
    setShowModalMulti(true);
    // Set multi select action to be performed
    setMultiSelectAction(action);
  };

  // Sets selected rows to the selected rows in the datagrid
  const handleSelectionModelChange = (selection) => {
    setSelectedRows(selection);
  };

  // Custom Footer
  const CustomFooter = () => {
    const nPages = Math.ceil(totalCount / recordsPerPage);
    return (
      <GridFooterContainer>
        <GridFooterContainer sx={{ justifyContent: "flex-start" }} />
        <GridFooterContainer sx={{ justifyContent: "flex-end" }}>
          {/* Add what you want here */}
          <GridFooter
            sx={{
              border: "none",
            }}
          />
          <div>
            <Pagination
              nPages={nPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>

          {/* / </Stack> */}
        </GridFooterContainer>
      </GridFooterContainer>
    );
  };

  if (isInitialLoading) {
    return <TableRowsSkeleton columns={columns} rowCount={3} rowHeight={55} />;
  }

  return (
    <ExpandableGrid
      title="Pending Approvals"
      rowCount={rows?.length ?? 0}
      filtersSlot={filtersSlot}
      chipsSlot={chipsSlot}
      pageSize={recordsPerPage}
      defaultPageSize={defaultRecordsPerPage}
      onPageSizeChange={onRecordsPerPageChange}
      pageSizes={[10, 25, 50, 100]}
      selectedCount={selectedRows.length}
      actions={
        canReviewRequests
          ? [
              { label: "Approve selected", onClick: () => openModal("accepted") },
              { label: "Reject selected", onClick: () => openModal("rejected"), danger: true },
            ]
          : []
      }
    >
      {(gridProps) => (
      <DataGrid
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: "14.5px !important",
            fontWeight: "bold !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#f6f6f6",
            maxHeight: "45px",
          },
          "& .MuiDataGrid-columnHeadersInner": {
            backgroundColor: "#f6f6f6 !important",
          },
          "& .MuiDataGrid-row": {
            minHeight: "55px !important",
            boxShadow: "none !important",
            borderBottom: "0.5px solid #d4d4d4",
          },
          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto",
          },
        }}
        rowHeight={40}
        getRowHeight={() => "auto"}
        key={dataGridKey}
        getRowId={(row) => row.id}
        // id={currentRecords.id}
        rows={rows}
        columns={columns}
        components={{ Footer: CustomFooter, ...gridProps.components }}
        componentsProps={gridProps.componentsProps}
        disableVirtualization
        disableColumnFilter
        disableColumnMenu
        disableSelectionOnClick
        getRowSpacing={(params) => ({
          top: params.isFirstVisible ? 0 : 3,
          bottom: params.isLastVisible ? 0 : 3,
        })}
        localeText={customLocaleText}
        checkboxSelection={canReviewRequests}
        onSelectionModelChange={handleSelectionModelChange}
        selectionModel={selectedRows}
        isRowSelectable={(params) => canReviewRequests && params.row.status === "pending"}
        loadingOverlayClassName="custom-loading-indicator"
        loading={isMultiActionLoading || isTableLoading}
      />
      )}
    </ExpandableGrid>
  );
};

export default AdminDataGrid;
